import Icon from "@mui/icons-material/EventBusy";
import EmployeeLeaveRequestCreate from "./EmployeeLeaveRequestCreate";
import EmployeeLeaveRequestList from "./EmployeeLeaveRequestList";
import EmployeeLeaveRequestShow from "./EmployeeLeaveRequestShow";

export default {
  list: EmployeeLeaveRequestList,
  create: EmployeeLeaveRequestCreate,
  show: EmployeeLeaveRequestShow,
  icon: Icon,
  label: "Leave Requests",
  options: { label: "Leave Requests" },
  name: "employeeLeaveRequests",
};
